import { Icon } from "../components/Icon.js";

export function NotificationsPage() {
  return (
    <div className="bg-surface-container border border-outline-variant rounded-xl p-xl flex flex-col items-center text-center gap-md min-h-[420px] justify-center">
      <Icon name="notifications" className="text-primary-fixed-dim/60" style={{ fontSize: "56px" }} />
      <h1 className="text-display-xl text-on-background">Notifications</h1>
      <p className="max-w-md text-body-base text-on-surface-variant">
        Email / Slack / SMS routing for sync failures and auth-loss alerts. Configurable here once we wire the
        delivery channels — currently the hub just logs.
      </p>
      <span className="font-mono text-label-xs uppercase tracking-widest text-on-surface-variant border border-outline-variant rounded-lg px-3 py-1.5 mt-2">
        Phase 1.5
      </span>
    </div>
  );
}
